import html2pdf from "html2pdf.js";
import React, { useState, useRef, useEffect } from "react";
//import QRCode from "react-qr-code";
import { numberToWords, formatPrice } from "../../utils/Common";
import PdfHtmlContent from "./PdfHtmlContent/PdfHtmlContent";
import PdfHtmlFor2mm from "./PdfHtmlContentFor2mm/PdfHtmlFor2mm";
import PdfHtmlFor3mm from "./PdfHtmlContentFor3mm/PdfHtmlContentFor3mm";
import Watermark from "./Watermark/Watermark";
import { FaChevronDown, FaCloudDownloadAlt } from "react-icons/fa";
import { IoPrint } from "react-icons/io5";
import { event } from "jquery";
import { useNavigate } from "react-router-dom";
import DeliveryInvoice from "./DeliveryInvoicePage/DeliveryInvoice";
import DeliveryInvoice3mm from "./DeliveryInvoicePage/DeliveryInvoice3mm";
import DeliveryInvoice2mm from "./DeliveryInvoicePage/DeliveryInvoice2mm";
import PdfHtmlContentA3 from "./PdfHtmlContentA3/PdfHtmlContentA3";
import DeliveryInvoiceA3 from "./DeliveryInvoicePage/DeliveryInvoiceA3";
import PdfHtmlContentA3Challan from "./PdfHtmlContentA3Challan/PdfHtmlContentA3Challan";
import DeliveryInvoiceA3Challan from "./DeliveryInvoicePage/DeliveryInvoiceA3Challan";
import { Modal } from "../../utils/Modal";
import styles from "./PdfHtmlContentFor3mm/PdfHtmlContentFor3mm.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { formatPhoneNumber, invoiceCalculate } from "../../utils/Common";
//import QRCode from 'qrcode';
import html2canvas from "html2canvas";
import PdfHtmlFor3mmNew from "./PdfHtmlContentFor3mm/PdfHtmlContentFor3mmNew";

const BASE_URL = process.env.REACT_APP_ROOT_URL;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const InvoiceDetail = (props) => {
  const [pageSelect, setpageSelect] = useState(null);
  const [downloadPdfView, setdownloadPdfView] = useState(false);
  const [dropdownPdf, setDropdownPdf] = useState(false);
  const [dropdownPrint, setDropdownPrint] = useState(false);
  const [printContentVisible, setPrintContentVisible] = useState(false);
  const originalContents = document.body.innerHTML;
  const navigate = useNavigate();

  const {
    invoice,
    invoiceCondition,
    paperSize,
    deliveryMode,
    invoiceImeis,
    inputs,
    exChangeImeis,
  } = props;

  const invoiceDate = new Date(invoice.created_at);
  const year = invoiceDate.getFullYear();
  const month = String(invoiceDate.getMonth() + 1).padStart(2, "0");
  const monthName = invoiceDate.toLocaleString("en-US", { month: "long" });
  const day = String(invoiceDate.getDate()).padStart(2, "0");
  const hours = String(invoiceDate.getHours() % 12).padStart(2, "0");
  const minutes = String(invoiceDate.getMinutes()).padStart(2, "0");
  const ampm = invoiceDate.getHours() >= 12 ? "PM" : "AM";
  const [id, setId] = useState("");
  const [showPrintOptions, setShowPrintOptions] = useState(false);
  const [loading, setLoading] = useState(false);
  const loadingCallback = (loading) => {
    setLoading(loading);
  };

  const formattedDate = `${year}-${month}-${day}`;
  const formattedTime = `${hours}:${minutes}${ampm}`;
  const formattedDateTime = `${day} ${monthName} ${year} ( ${hours}:${minutes}${ampm} )`;

  const shop_logo = invoice?.user_info?.invoice_settings?.shop_logo
    ? invoice?.user_info?.invoice_settings?.shop_logo
    : `${BASE_URL}/layoutlogo.svg`;
  //const shop_logo = `${BASE_URL}/layoutlogo.svg`;
  let totalQty = 0;
  let totalDiscount = 0;

  const shopType = parseInt(invoice?.user_info?.type);
  console.log("Shop Type .... ", shopType);
  console.log("Invoice......", invoice);
  // const handlePrint = (elementId) => {
  //   const printElement = document.getElementById(elementId);

  //   if (printElement) {
  //     setPrintContentVisible(true);
  //     const printContents = printElement.innerHTML;
  //     document.body.innerHTML = printContents;
  //     window.print();
  //   } else {
  //     console.error(`Element with id "${elementId}" not found.`);
  //   }
  // };

const handlePrint = (elementId) => {
  const printContents = document.getElementById(elementId);
  if (!printContents) return;

  // Save original body
  const originalContents = document.body.innerHTML;

  // Create a temporary container
  const tempContainer = document.createElement("div");
  tempContainer.innerHTML = printContents.innerHTML;

  // Apply inline print padding/margin directly
  //tempContainer.style.margin = "10mm auto";  // top/bottom 10mm, center horizontally
  tempContainer.style.padding = "5mm";      // gaps from edges

  // Append print-specific styles
  const style = document.createElement("style");
  style.innerHTML = `
    @media print {
      html, body {
        margin: 0 !important;
        padding: 0 !important;
        height: auto !important;
        overflow: visible !important;
      }

      * {
        box-sizing: border-box !important;
      }

      table {
        page-break-inside: auto !important;
        border-collapse: collapse !important;
      }

      tr {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
      }

      img {
        max-width: 100% !important;
        height: auto !important;
      }
    }
  `;
  tempContainer.appendChild(style);

  // Replace body with temp container
  document.body.innerHTML = "";
  document.body.appendChild(tempContainer);

  // Trigger print
  window.print();

  // Restore original body after print
  document.body.innerHTML = originalContents;
};



 const handlePrintToken = (elementId = "pdfConentAreasToken") => {
  const printElement = document.getElementById(elementId);

  if (printElement) {
    // Get the content of the element to print
    const printContents = printElement.innerHTML;

    // Create specific styles for 3-inch thermal receipt paper
    // with positioning at the top middle of the page and increased top margin
    const printStyles = `
      <style>
        @media print {
          @page {
            size: 3in auto; /* Width: 3 inches, Height: auto */
            margin: 0;
          }

          html, body {
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: flex-start;
          }

          .print-wrapper {
            width: 3in;
            padding-top: 0.5in; /* Increased top margin from 0.2in to 0.5in */
            font-family: 'Courier New', monospace;
            font-size: 10px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            padding: 2px;
            text-align: left;
          }

          .receipt-divider {
            border-bottom: 1px dashed #000;
            margin: 0.1in 0;
            width: 100%;
          }

          .receipt-header, .receipt-footer {
            text-align: center;
          }

          .token-number {
            font-size: 18px;
            font-weight: bold;
          }

          .shop-name {
            font-size: 12px;
            font-weight: bold;
          }
        }
      </style>
    `;

    // Create a new window for printing
    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      alert("Please allow pop-ups to print the receipt");
      return;
    }

    // Write the content to the new window with centering wrapper
    printWindow.document.write(`
      <html>
        <head>
          <title>Restaurant Token</title>
          ${printStyles}
        </head>
        <body>
          <div class="print-wrapper">
            ${printContents}
          </div>
        </body>
      </html>
    `);

    printWindow.document.close();

    // Wait for content to load before printing
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);

  } else {
    console.error(`Element with id "${elementId}" not found.`);
  }
};

//   const handlePrintToken = (elementId = "pdfConentAreasToken") => {
//   const printElement = document.getElementById(elementId);

//   if (printElement) {
//     // Get the content of the element to print
//     const printContents = printElement.innerHTML;

//     // Create specific styles for 3-inch thermal receipt paper
//     const printStyles = `
//       <style>
//         @media print {
//           body {
//             margin: 0;
//             padding: 0;
//             width: 3in;
//             font-family: 'Courier New', monospace;
//             font-size: 10px;
//           }
//           @page {
//             size: 3in auto; /* Width: 3 inches, Height: auto */
//             margin: 0.1in 0; /* Minimal margins for thermal receipt */
//           }
//           table {
//             width: 100%;
//             border-collapse: collapse;
//           }
//           th, td {
//             padding: 2px;
//             text-align: left;
//           }
//           .receipt-divider {
//             border-bottom: 1px dashed #000;
//             margin: 0.1in 0;
//             width: 100%;
//           }
//           .receipt-header, .receipt-footer {
//             text-align: center;
//           }
//           .token-number {
//             font-size: 18px;
//             font-weight: bold;
//           }
//           .shop-name {
//             font-size: 12px;
//             font-weight: bold;
//           }
//         }
//       </style>
//     `;

//     // Combine styles and content
//     const printableHTML = `
//       ${printStyles}
//       <div style="width: 3in; max-width: 3in;">
//         ${printContents}
//       </div>
//     `;

//     // Create a new window for printing to avoid disrupting the main application
//     const printWindow = window.open('', '_blank');

//     if (!printWindow) {
//       alert("Please allow pop-ups to print the receipt");
//       return;
//     }

//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Restaurant Token</title>
//         </head>
//         <body>
//           ${printableHTML}
//         </body>
//       </html>
//     `);

//     printWindow.document.close();

//     // Wait for content to load before printing
//     setTimeout(() => {
//       printWindow.print();
//       printWindow.close();
//     }, 250);

//   } else {
//     console.error(`Element with id "${elementId}" not found.`);
//   }
// };

  //  const handlePrintA4Customize = (elementId) => {
  //     const printContent = document.getElementById(elementId);
  //     const windowPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

  //     if (windowPrint) {
  //       windowPrint.document.write(`
  //         <!DOCTYPE html>
  //         <html>
  //           <head>
  //             <title>Print Invoice</title>
  //             <meta name="color-scheme" content="normal">
  //             <meta name="color-rendering" content="optimizeQuality">
  //             <style>
  //               ${document.querySelector('style').innerHTML}

  //               @media not print {
  //                 body {
  //                   background: white;
  //                 }
  //               }

  //               @page {
  //                 margin: 0;
  //                 size: auto;
  //               }
  //             </style>
  //           </head>
  //           <body>
  //             ${printContent.outerHTML}
  //           </body>
  //         </html>
  //       `);

  //       windowPrint.document.close();
  //       windowPrint.focus();

  //       // Wait for resources to load
  //       setTimeout(() => {
  //         windowPrint.print();
  //         // windowPrint.close();
  //       }, 250);
  //     }
  //   };

  window.onafterprint = () => {
    setPrintContentVisible(false);
    document.body.innerHTML = originalContents;
    // Restore original content
    window.location.reload();
  };

  const handleGeneratePdf = async (pageSize, pageSizeNumber) => {
    const element = document.getElementById("pdfConentAreas");
    const element2 = document.getElementById("pdfConentAreas3");
    const element3 = document.getElementById("pdfConentAreas2");
    const element4 = document.getElementById("pdfConentAreasA3");
    const element5 = document.getElementById("pdfConentAreasA3Challan");

    let selectedElement;
    setdownloadPdfView(true);
    if (pageSizeNumber === 1) {
      setId("pdfConentAreas");
      console.log("page size", pageSizeNumber);
      console.log(element);
      setpageSelect(pageSizeNumber);

      selectedElement = element;
    } else if (pageSizeNumber === 2) {
      setId("pdfConentAreas3");
      console.log("page size", pageSizeNumber);
      setpageSelect(pageSizeNumber);
      selectedElement = element2;
    } else if (pageSizeNumber === 3) {
      setId("pdfConentAreas2");
      console.log("page size", pageSizeNumber);
      setpageSelect(pageSizeNumber);
      selectedElement = element3;
    } else if (pageSizeNumber === 4) {
      setId("pdfConentAreasA3");
      console.log("page size", pageSizeNumber);
      setpageSelect(pageSizeNumber);
      selectedElement = element4;
    } else if (pageSizeNumber === 5) {
      setId("pdfConentAreasA3Challan");
      console.log("page size", pageSizeNumber);
      setpageSelect(pageSizeNumber);
      selectedElement = element5;
    }

    const formatOptions = {
      a4: "a4",
      "3mm": [80, 297],
      "2mm": [56, 297],
      a3: [117, 254],
    };
    const shopLogoUrlWithProxy = `<span class="math-inline">${API_BASE_URL}</span>${shop_logo}`; // Prepend proxy URL

    const opt = {
      margin: 0.1,
      filename: "myPdf.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 900 / 96,
        proxy: shopLogoUrlWithProxy,
        useCORS: true,
        allowTaint: false,
        logging: false,
      },
      jsPDF: {
        unit: "mm",
        format: formatOptions[pageSize],
        orientation: "portrait",
        marginLeft: 10,
        marginRight: 10,
        image: { type: "jpeg", quality: 1 },
        fontFaces: [{ family: "Arial", src: "path/to/arial.ttf" }],
      },
    };

    const generatePdf = () => {
      html2pdf()
        .set(opt)
        .from(selectedElement)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          pdf.save(`${invoice.invoice_id}_invoice_${pageSize}.pdf`);
        });
    };

    const images = selectedElement?.querySelectorAll("img");
    let loadedImages = 0;

    // const checkImagesLoaded = () => {
    //   loadedImages++;

    //   if (loadedImages === images?.length) {
    generatePdf();
    //   }
    // };

    // if (images != null) {
    //   images.forEach(img => {
    //     img.addEventListener('load', checkImagesLoaded);
    //   })
    // };

    // if (images != null) {
    //   images.forEach(img => {
    //     if (img.complete) {
    //       checkImagesLoaded();
    //     }
    //   })
    // };
  };

  const handleNavigate = () => {
    navigate("/invoice");
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((shopType === 4 || shopType === 2) && e.key === "Enter") {
        handlePrint("pdfConentAreas3");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [shopType]);

  // const handlePrintInNewTab = (elementId) => {
  //   const printElement = document.getElementById(elementId);

  //   if (printElement) {
  //     const printContents = printElement.innerHTML;

  //     // Open a new tab
  //     const printWindow = window.open('', '_blank');

  //     // Write the HTML content into the new tab
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Print Invoice</title>
  //           <style>
  //             /* Add any custom styles here to match your styling */
  //             body { font-family: Arial, sans-serif; font-size: 14px; padding: 10px; margin: 0; }
  //           </style>
  //         </head>
  //         <body onload="window.print(); window.close();">
  //           ${printContents}
  //         </body>
  //       </html>
  //     `);
  //     printWindow.document.close();
  //   } else {
  //     console.error(`Element with id "${elementId}" not found.`);
  //   }
  // };

  // const openInvoiceInNewTab = () => {
  //   const newTab = window.open('', '_blank');
  //   const htmlContent = `
  //     <!DOCTYPE html>
  //     <html>
  //     <head>
  //       <title>Invoice</title>
  //       <style>
  //         ${styles}
  //       </style>
  //     </head>
  //     <body>
  //       ${document.getElementById('pdfConentAreas3').outerHTML}
  //     </body>
  //     </html>
  //   `;
  //   newTab.document.open();
  //   newTab.document.write(htmlContent);
  //   newTab.document.close();
  //   newTab.focus();
  // };

  // const openInvoiceInNewTab = () => {
  //   const newTab = window.open('', '_blank');
  //   const htmlContent = `
  //     <!DOCTYPE html>
  //     <html>
  //     <head>
  //       <title>Invoice</title>
  //       <style>
  //         .pdfConentAreas3 {
  //           font-family: Arial, Helvetica, sans-serif;
  //           font-weight: 800;
  //           color: rgb(0, 0, 0);
  //         }
  //         .headingTable { margin: 0 0 20px 0; }
  //         tbody, th { font-family: Arial, Helvetica, sans-serif; font-weight: 800; color: rgb(0, 0, 0); }
  //         .headingTable td { font-size: 12px; }
  //         .headingPDf { text-align: center; margin: 0 0 10px 0; font-size: 22px; }
  //         .invoice-customer { font-family: Arial, Helvetica, sans-serif; font-weight: 800; color: rgb(0, 0, 0); }
  //         img.logoImage { width: 120px; margin: 0 0 10px 0; }
  //         .pdfConentAreas3 table { width: 100%; border-spacing: 0; border-collapse: collapse; }
  //         .pdfConentAreas3 table td { margin: 0; }
  //       </style>
  //     </head>
  //     <body>
  //       ${document.getElementById('pdfConentAreas3').outerHTML}
  //     </body>
  //     </html>
  //   `;
  //   newTab.document.open();
  //   newTab.document.write(htmlContent);
  //   newTab.document.close();
  //   newTab.focus();
  // };

  // const invoiceRef = useRef(null);
  // //const logoRef = useRef(null);
  // let totalItems = 0;
  // const handleTotalQtyUpdate = (newTotalQty) => {
  //   console.log("Updated Total Quantity in Parent: ", newTotalQty);
  //   totalItems=newTotalQty;
  // };
  // const handlePdf = async () => {
  //   const invoicepdf = invoiceRef.current;
  //   const doc = new jsPDF();
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const contentWidth = pageWidth * 0.4; // Set desired content width, e.g., 70% of page width
  //   const centerX = (pageWidth - contentWidth) / 2; // Center alignment based on reduced width

  //   //header
  //   doc.setFontSize(8);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(`${invoice?.user_info?.outlet_name}`, pageWidth / 2, 20, { align: "center" });
  //   doc.text(`Address: ${invoice?.user_info?.address}`, pageWidth / 2, 25, { align: "center" });
  //   doc.text(`Mobile: ${invoice?.user_info?.invoice_settings?.mobile_number}`, pageWidth / 2, 30, { align: "center" });
  //   doc.text(`${invoice?.user_info?.invoice_settings?.social_link ? invoice?.user_info?.invoice_settings?.social_link : ("")}`, pageWidth / 2, 35, { align: "center" });

  //   doc.setFontSize(12);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(`Sales Receipt`, pageWidth / 2, 42, { align: "center" });

  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(`Invoice: ${invoice?.invoice_id}`, pageWidth / 2, 47, { align: "center" });

  //   const margin = centerX;
  //   const lineYPosition = 50;
  //   doc.line(margin, lineYPosition, pageWidth - margin, lineYPosition);

  //   const leftMargin = centerX;
  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(`Date: ${formattedDate}`, leftMargin, 55, );
  //   doc.text(`Time: ${formattedTime}`, leftMargin, 60, );

  //   let currentYPosition = 65;
  //   // Extract table content
  //   doc.autoTable({
  //     html : invoicepdf,
  //     // startY: 65,
  //     startY: currentYPosition,
  //     theme: 'plain',
  //     showHead : 'firstPage',
  //     margin: { left: centerX, right: centerX },
  //     headStyles: {
  //       fillColor: null,
  //       textColor: 'black',
  //       lineWidth: 0.5,
  //       lineColor: 'black',
  //     },
  //     bodyStyles: {
  //         fillColor: null,
  //         lineWidth: 0,
  //     },
  //     columnStyles: {
  //       1: { halign: 'center' },
  //       2: { halign: 'center' },
  //       3: { halign: 'right' }
  //     },
  //     pageBreak: 'auto',
  //   });

  //   const fontSize = 10;
  //   const lineHeight = 8;
  //   currentYPosition = doc.lastAutoTable.finalY + 5;

  //   const addSummaryRow = (label, value, yPosition) => {
  //   doc.setFontSize(fontSize);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(label, leftMargin, yPosition);
  //   const rightX = pageWidth - leftMargin ;  // Adjust 10px margin
  //   doc.text(String(value), rightX, yPosition, { align: 'right' });
  //   //doc.line(leftMargin, yPosition + 2, pageWidth - leftMargin, yPosition + 2);
  //   };

  //   // Add the summary below the table
  //   addSummaryRow('TOTAL ITEMS', totalItems, currentYPosition);
  //   currentYPosition += lineHeight;
  //   doc.line(leftMargin, currentYPosition + 2, pageWidth - leftMargin, currentYPosition + 2);

  //   addSummaryRow('SUB TOTAL', `${invoice?.sub_total} ${invoice?.user_info?.invoice_settings?.currency_info?.code || 'BDT'}`, currentYPosition);
  //   currentYPosition += lineHeight;
  //   doc.line(leftMargin, currentYPosition + 2, pageWidth - leftMargin, currentYPosition + 2);

  //   addSummaryRow('DISCOUNT', `${formatPrice(invoice?.discount || 0)} ${invoice?.user_info?.invoice_settings?.currency_info?.code || 'BDT'}`, currentYPosition);
  //   currentYPosition += lineHeight;
  //   doc.line(leftMargin, currentYPosition + 2, pageWidth - leftMargin, currentYPosition + 2);

  //   addSummaryRow('Vat', `${invoice?.vat ? formatPrice(invoice?.vat) : '0.00'} ${invoice?.user_info?.invoice_settings?.currency_info?.code || 'BDT'}`, currentYPosition);
  //   currentYPosition += lineHeight;
  //   doc.line(leftMargin, currentYPosition + 2, pageWidth - leftMargin, currentYPosition + 2);

  //   addSummaryRow('Service Charge', `${invoice?.tax ? formatPrice(invoice?.tax) : '0.00'} ${invoice?.user_info?.invoice_settings?.currency_info?.code || 'BDT'}`, currentYPosition);
  //   currentYPosition += lineHeight;
  //   //doc.line(leftMargin, currentYPosition + 2, pageWidth - leftMargin, currentYPosition + 2);

  //   addSummaryRow('Grand Total', `${formatPrice(invoiceCalculate(invoice).grandTotal)} ${invoice?.user_info?.invoice_settings?.currency_info?.code || 'BDT'}`, currentYPosition);
  //   currentYPosition += lineHeight;

  //   addSummaryRow('Paid Amount', `${formatPrice(invoice?.paid_amount || 0)} ${invoice?.user_info?.invoice_settings?.currency_info?.code || 'BDT'}`, currentYPosition);
  //   currentYPosition += lineHeight;

  //   // Add the Due Amount row with underline
  //   addSummaryRow('Due Amount', `${formatPrice(invoiceCalculate(invoice).dueAmount) } ${invoice?.user_info?.invoice_settings?.currency_info?.code || 'BDT'}`, currentYPosition);
  //   //currentYPosition += lineHeight;
  //   doc.line(leftMargin, currentYPosition + 2, pageWidth - leftMargin, currentYPosition + 2); // Underline for Due Amount only

  //   doc.setFontSize(8);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(`In word: ${numberToWords(formatPrice(invoice?.paid_amount))} taka only`, pageWidth / 2, currentYPosition + 8, { align: "center" });

  //   doc.setFontSize(8);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(`YOU SAVED ${formatPrice(invoice?.discount ? invoice?.discount : 0)}${invoice?.user_info?.invoice_settings?.currency_info?.code ? invoice?.user_info?.invoice_settings?.currency_info?.code : ' BDT'} TAKA IN THIS PURCHASE`, pageWidth / 2, currentYPosition + 16, { align: "center" });

  //   doc.setFontSize(8);
  //   doc.setFont("helvetica", "bold");
  //   doc.text(`THANKS FOR PURCHASE`, pageWidth / 2, currentYPosition + 20, { align: "center" });

  //   const qrCodeUrl = await QRCode.toDataURL(`${BASE_URL}/invoice/${invoice?.invoice_id}`, { width: 60 });
  //   const qrCodeSize = 15; // Smaller QR code size
  //   const qrCodeX = (pageWidth - qrCodeSize) / 2; // Center align
  //   const qrCodeY = currentYPosition + 22; // Slightly below the "THANKS FOR PURCHASE" text
  //   doc.addImage(qrCodeUrl, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize);

  //   doc.setFontSize(7);
  //   doc.setFont("helvetica");
  //   doc.text(`A PRODUCT OF SQUAD INNOVATORS`, pageWidth / 2, currentYPosition + 40, { align: "center" });

  //   const linkYPosition = currentYPosition + 43; // Adjust position below QR code
  //   const websiteUrl = "https://www.outletexpense.com";
  //   doc.setFontSize(6);
  //   doc.textWithLink("www.outletexpense.com", pageWidth / 2, linkYPosition, { align: "center", url: websiteUrl });

  //   // addSummaryRow('Grand Totals', `${formatPrice(invoiceCalculate(invoice).grandTotal)} ${invoiceSetting?.currency_info?.code || 'BDT'}`, currentYPosition);
  //   doc.output('dataurlnewwindow')
  // }

  const [kitchenPrintDropdown, setKitchenPrintDropdown] = useState(false);

  const groupedByKitchen = {};
  console.log("invoice sale_dettails....", invoice?.sales_details)
  invoice?.sales_details?.forEach((item) => {
    const kitchenId = item.product_info?.kitchen_id;
    if (!kitchenId) return;

    if (!groupedByKitchen[kitchenId]) {
      groupedByKitchen[kitchenId] = {
        kitchenName: item.product_info?.kitchen?.name || "Unnamed Kitchen",
        items: []
      };
    }
    groupedByKitchen[kitchenId].items.push(item);
  });

  return (
    <>
      <div>
        {/* <div className={`${paperSize == 'A4' ? 'block' : 'hidden'}`} >
        <PdfHtmlContent
          shop_logo={shop_logo}
          invoice={invoice}
          invoiceSetting={invoice?.user_info?.invoice_settings}
        />
      </div> */}
        <div
          className={
            String(invoice.delivery_method?.type_name).toLowerCase() !=
            "hand-to-hand"
              ? "hidden"
              : ""
          }
        >
          {paperSize === "A4" && (
            <PdfHtmlContent
              shop_logo={shop_logo}
              invoice={invoice}
              invoiceImeis={invoiceImeis}
              id={"pdfConentAreas"}
              invoiceSetting={invoice?.user_info?.invoice_settings}
              inputs={inputs}
              exChangeImeis={exChangeImeis}
            />
          )}
        </div>
        {String(invoice.delivery_method?.type_name).toLowerCase() ==
        "hand-to-hand" ? (
          <div>
            {console.log("invoice", invoice)}
            {/* {paperSize === '3mm' && (
            <PdfHtmlFor3mm
              shop_logo={shop_logo}
              invoice={invoice}
              id={"pdfConentAreas3"}
              invoiceSetting={invoice?.user_info?.invoice_settings}
            />
          )} */}
            <div className="hidden">
              <PdfHtmlFor3mm
                shop_logo={shop_logo}
                invoice={invoice}
                id={"pdfConentAreas3"}
                invoiceSetting={invoice?.user_info?.invoice_settings}
                // invoiceRef={invoiceRef}
                // logoRef={logoRef}
                // updateTotalQty={handleTotalQtyUpdate}
              />
            </div>
            <div className="hidden">
              <PdfHtmlFor3mmNew
                shop_logo={shop_logo}
                invoice={invoice}
                id={"pdfConentAreas3New"}
                invoiceSetting={invoice?.user_info?.invoice_settings}
                // invoiceRef={invoiceRef}
                // logoRef={logoRef}
                // updateTotalQty={handleTotalQtyUpdate}
              />
            </div>
            {/* {paperSize === '2mm' && (
            <PdfHtmlFor2mm
              shop_logo={shop_logo}
              invoice={invoice}
              id={"pdfConentAreas2"}
              invoiceSetting={invoice?.user_info?.invoice_settings}
            />
          )} */}
            <div className="hidden">
              <PdfHtmlFor2mm
                shop_logo={shop_logo}
                invoice={invoice}
                id={"pdfConentAreas2"}
                invoiceSetting={invoice?.user_info?.invoice_settings}
              />
            </div>
            <div className="hidden">
              <PdfHtmlContentA3
                shop_logo={shop_logo}
                invoice={invoice}
                id={"pdfConentAreasA3"}
                invoiceSetting={invoice?.user_info?.invoice_settings}
              />
            </div>
            <div className="hidden">
              <PdfHtmlContentA3Challan
                shop_logo={shop_logo}
                invoice={invoice}
                id={"pdfConentAreasA3Challan"}
                invoiceSetting={invoice?.user_info?.invoice_settings}
              />
            </div>
          </div>
        ) : (
          <div>
            {console.log("invoice in other method", invoice)}
            <DeliveryInvoice
              shop_logo={shop_logo}
              invoice={invoice}
              invoiceSetting={invoice?.user_info?.invoice_settings}
              invoiceImeis={invoiceImeis}
              id={"pdfConentAreas"}
              inputs={inputs}
            />
            <div className="hidden">
              <DeliveryInvoice3mm
                shop_logo={shop_logo}
                invoice={invoice}
                id={"pdfConentAreas3"}
                invoiceSetting={invoice?.user_info?.invoice_settings}
              />
            </div>
            <div className="hidden">
              <DeliveryInvoice2mm
                shop_logo={shop_logo}
                invoice={invoice}
                id={"pdfConentAreas2"}
                invoiceSetting={invoice?.user_info?.invoice_settings}
              />
            </div>
            <div className="hidden">
              <DeliveryInvoiceA3
                shop_logo={shop_logo}
                invoice={invoice}
                id={"pdfConentAreasA3"}
                invoiceSetting={invoice?.user_info?.invoice_settings}
              />
            </div>
            <div className="hidden">
              <DeliveryInvoiceA3Challan
                shop_logo={shop_logo}
                invoice={invoice}
                id={"pdfConentAreasA3Challan"}
                invoiceSetting={invoice?.user_info?.invoice_settings}
              />
            </div>
          </div>
        )}

        {/* new pdf and print buttons */}
        <div className="flex flex-col sm:flex-row gap-12  justify-between text-xs md:text-sm lg:text-base mt-6">
          {console.log(invoice)}
          {/* pdf buttons */}
          <div
            className={`flex-1 transform duration-300 hidden sm:block ${
              dropdownPdf || dropdownPrint
                ? "!h-[270px] md:!h-[300px]"
                : "h-[90px]"
            } space-y-2 relative`}
          >
            {/* pdf drop down button */}
            <button
              // onClick={() => setDropdownPdf(!dropdownPdf)}
              className=" flex justify-center gap-1 md:gap-3 items-center bg-[#f1effc] text-[#034AFF] absolute z-10 !px-1 py-3 w-full rounded-xl font-bold shadow-md"
            >
              <span>
                <FaCloudDownloadAlt size={22} />
              </span>{" "}
              Download PDF{" "}
              <div
                className={`transform duration-300 ${
                  dropdownPdf ? "-rotate-180" : ""
                }`}
              >
                {" "}
                <FaChevronDown size={18} />
              </div>
            </button>
            {/* child buttons */}
            <button
              onClick={() => handleGeneratePdf("a4", 1)}
              className={`text-[#034AFF] font-semibold flex gap-1 md:gap-3  items-center justify-center ${
                dropdownPdf
                  ? "translate-y-[3.7rem] "
                  : "-translate-y-[0.6rem] opacity-0"
              } hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300 hover:text-[#eaeffb] py-3 w-full  rounded-xl`}
            >
              <FaCloudDownloadAlt size={22} /> <span>Download A4 PDF</span>
            </button>
            <button
              onClick={() => handleGeneratePdf("3mm", 2)}
              className={`text-[#034AFF] font-semibold flex gap-1 md:gap-3 items-center justify-center ${
                dropdownPdf
                  ? "translate-y-[3.7rem] "
                  : "-translate-y-[4.8rem] opacity-0"
              }  hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300 hover:text-[#eaeffb] py-3 w-full  rounded-xl`}
            >
              <FaCloudDownloadAlt size={22} /> <span>Download 3mm PDF</span>
            </button>
            <button
              onClick={() => handleGeneratePdf("2mm", 3)}
              className={` text-[#034AFF] font-semibold flex gap-1 md:gap-3 items-center justify-center ${
                dropdownPdf
                  ? "translate-y-[3.7rem] "
                  : "-translate-y-[8.4rem] opacity-0"
              } border hover:bg-[#034AFF] hover:border-[1px_solid_#D2CDFF] transform duration-300 hover:text-[#eaeffb] py-3 w-full  rounded-xl`}
            >
              <FaCloudDownloadAlt size={22} /> <span>Download 2mm PDF</span>
            </button>
          </div>
          <div
            className={`flex-1 space-y-2 relative`}
          >
            {/* <button
              // onClick={() => handleGeneratePdf("token", 4)}
              onClick={() => {
                handlePrintToken("pdfConentAreasToken");
              }}
              className="text-[#034AFF] font-semibold flex gap-1 md:gap-3 items-center justify-center bg-[#f1effc] hover:bg-[#034AFF] hover:text-[#eaeffb] border hover:border-[1px_solid_#D2CDFF] transform duration-300 py-3 w-full rounded-xl shadow-md"
            >
              <FaCloudDownloadAlt size={22} /> <span>Print Token</span>
            </button> */}
            {/* Print Dropdown Button */}
            <button
              onClick={() => setKitchenPrintDropdown(!kitchenPrintDropdown)}
              className="bg-[#f1effc] flex justify-center items-center gap-1 md:gap-3 text-[#034AFF] font-bold shadow-md !px-1 py-3 w-full rounded-xl"
            >
              <span>
                <IoPrint size={22} />
              </span>
              Print Token
              <div
                className={`transform duration-300 ${
                  kitchenPrintDropdown ? "-rotate-180" : ""
                }`}
              >
                <FaChevronDown size={18} />
              </div>
            </button>

            {/* Dropdown List (conditionally shown) */}
            {kitchenPrintDropdown && (
              <div className="absolute top-[70%] mt-2 bg-white w-full shadow-lg rounded-xl z-20 p-2 max-h-[220px] overflow-y-auto no-scrollbar space-y-2">
                {Object.entries(
                  invoice?.sales_details.reduce((acc, item) => {
                    const kitchenId = item.product_info?.kitchen_id;
                    if (!kitchenId) return acc;
                    if (!acc[kitchenId]) {
                      acc[kitchenId] = {
                        kitchenName: item.product_info?.kitchen?.name || "Unnamed Kitchen",
                      };
                    }
                    return acc;
                  }, {})
                ).map(([kitchenId, group]) => (
                  <button
                    key={kitchenId}
                    onClick={() => handlePrintToken(`pdfKitchenToken-${kitchenId}`)}
                    className="flex gap-1 md:gap-3 items-center justify-center w-full text-left px-4 py-2 rounded-lg text-sm font-medium text-[#034AFF] hover:bg-[#f1effc] duration-200"
                  >
                    <IoPrint size={22} />
                    <span>Print {group.kitchenName}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
          {/* print buttons */}
          <div
            className={`flex-1 space-y-2 transform duration-300 ${
              dropdownPdf || dropdownPrint
                ? "!h-[270px] md:!h-[300px]"
                : "h-[60px]"
            } relative overflow-y-scroll no-scrollbar`}
          >
            {/* print drop down button */}
            <button
              onClick={() => setDropdownPrint(!dropdownPrint)}
              className=" bg-[#f1effc] flex justify-center items-center gap-1 md:gap-3 text-[#034AFF] font-bold shadow-md absolute z-10 !px-1 py-3 w-full rounded-xl"
            >
              <span>
                <IoPrint size={22} />
              </span>{" "}
              Print{" "}
              <div
                className={`transform duration-300 ${
                  dropdownPrint ? "-rotate-180" : ""
                }`}
              >
                {" "}
                <FaChevronDown size={18} />
              </div>
            </button>
            {/* child buttons */}
             {(shopType !== 4 && shopType !== 2) && <>
              <button
                  onClick={() => {
                    handlePrint("pdfConentAreasCustomize");
                  }}
                  className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                    dropdownPrint
                      ? "translate-y-[3.7rem] "
                      : "-translate-y-[0.6rem] opacity-0"
                  } hover:text-[#eaeffb] hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300  py-3 w-full  rounded-xl`}
                >
                  <IoPrint size={22} />
                  <span>Print A4 (Customize)</span>
                </button>
                {/* child buttons */}
                <button
                  onClick={() => {
                    handlePrint("pdfConentAreasPad");
                  }}
                  className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                    dropdownPrint
                      ? "translate-y-[3.7rem] "
                      : "-translate-y-[0.6rem] opacity-0"
                  } hover:text-[#eaeffb] hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300  py-3 w-full  rounded-xl`}
                >
                  <IoPrint size={22} />
                  <span>Print A4 (Pad)</span>
                </button>
                {/* child buttons */}
                <button
                  onClick={() => {
                    handlePrint("pdfConentAreasPadCustomize");
                  }}
                  className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                    dropdownPrint
                      ? "translate-y-[3.7rem] "
                      : "-translate-y-[0.6rem] opacity-0"
                  } hover:text-[#eaeffb] hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300  py-3 w-full  rounded-xl`}
                >
                  <IoPrint size={22} />
                  <span>Print A4 (Pad Customize)</span>
                </button>
                {/* child buttons */}
                <button
                  onClick={() => {
                    handlePrint("pdfConentAreas");
                  }}
                  className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                    dropdownPrint
                      ? "translate-y-[3.7rem] "
                      : "-translate-y-[0.6rem] opacity-0"
                  } hover:text-[#eaeffb] hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300  py-3 w-full  rounded-xl`}
                >
                  <IoPrint size={22} />
                  <span>Print A4</span>
                </button>
                <button
                  onClick={() => {
                    handlePrint("pdfConentAreasCustomizeWithoutColor");
                  }}
                  className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                    dropdownPrint
                      ? "translate-y-[3.7rem] "
                      : "-translate-y-[0.6rem] opacity-0"
                  } hover:text-[#eaeffb] hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300  py-3 w-full  rounded-xl`}
                >
                  <IoPrint size={22} />
                  <span>Print A4 (Customize Without Color)</span>
                </button>
                <button
                  onClick={() => {
                    handlePrint("pdfConentAreasBrandNew");
                  }}
                  className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                    dropdownPrint
                      ? "translate-y-[3.7rem] "
                      : "-translate-y-[0.6rem] opacity-0"
                  } hover:text-[#eaeffb] hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300  py-3 w-full  rounded-xl`}
                >
                  <IoPrint size={22} />
                  <span>Print A4 (Brand New)</span>
                </button>
              </>
            }
            {/* {(invoice.delivery_method?.type_name =='hand-to-hand') && */}
            <button
              onClick={() => {
                handlePrint("pdfConentAreas3");
              }}
              className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                dropdownPrint
                  ? "translate-y-[3.7rem] "
                  : "-translate-y-[4.8rem] opacity-0"
              }  hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300 hover:text-[#eaeffb] py-3 w-full  rounded-xl`}
            >
              <IoPrint size={22} /> <span>Print 3 inch</span>
            </button>
            <button
              onClick={() => {
                handlePrint("pdfConentAreas3New");
              }}
              className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                dropdownPrint
                  ? "translate-y-[3.7rem] "
                  : "-translate-y-[4.8rem] opacity-0"
              }  hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300 hover:text-[#eaeffb] py-3 w-full  rounded-xl`}
            >
              <IoPrint size={22} /> <span>Print 3 inch New</span>
            </button>
            {/* <button
              onClick={() => { openInvoiceInNewTab('pdfConentAreas3') }}
              className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold ${dropdownPrint ? "translate-y-[3.7rem] " : "-translate-y-[4.8rem] opacity-0"} hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300 hover:text-[#eaeffb] py-3 w-full rounded-xl`}
            >
              <IoPrint size={22}/> <span>Print 3 inch</span>
            </button> */}
            {/* <button
              onClick={handlePdf}
              className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold ${dropdownPrint ? "translate-y-[3.7rem] " : "-translate-y-[4.8rem] opacity-0"} hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300 hover:text-[#eaeffb] py-3 w-full rounded-xl`}
            >
              <IoPrint size={22}/> <span>Print 3 inch</span>
            </button> */}

            {/* } */}
            {/* {(invoice.delivery_method?.type_name =='hand-to-hand') && */}
            {(shopType !== 4 && shopType !== 2) && <>
              <button
                onClick={() => {
                  handlePrint("pdfConentAreas2");
                }}
                className={` flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                  dropdownPrint
                    ? "translate-y-[3.7rem] "
                    : "-translate-y-[8.4rem] opacity-0"
                } border hover:bg-[#034AFF] hover:border-[1px_solid_#D2CDFF] transform duration-300 hover:text-[#eaeffb] py-3 w-full  rounded-xl`}
              >
                <IoPrint size={22} />
                <span>Print 2 inch</span>
              </button>
              {/* <button onClick={() => { handlePrint('pdfConentAreasA3') }} className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${dropdownPrint ? "translate-y-[3.7rem] " : "-translate-y-[0.6rem] opacity-0"} hover:text-[#eaeffb] hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300  py-3 w-full  rounded-xl`}>
                <IoPrint size={22}/><span>Print A3</span>
              </button>
              <button onClick={() => { handlePrint('pdfConentAreasA3Challan') }} className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${dropdownPrint ? "translate-y-[3.7rem] " : "-translate-y-[0.6rem] opacity-0"} hover:text-[#eaeffb] hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300  py-3 w-full  rounded-xl`}>
                <IoPrint size={22}/><span>Print A3 Challan</span>
              </button> */}
              <button
                htmlFor="choose_print_option"
                onClick={() => {
                  setShowPrintOptions(true);
                }}
                className={`flex gap-1 md:gap-3 items-center justify-center text-[#034AFF] font-semibold  ${
                  dropdownPrint
                    ? "translate-y-[3.7rem] "
                    : "-translate-y-[0.6rem] opacity-0"
                } hover:text-[#eaeffb] hover:bg-[#034AFF] border hover:border-[1px_solid_#D2CDFF] transform duration-300  py-3 w-full  rounded-xl`}
              >
                <IoPrint size={22} />
                <span>Print A5</span>
              </button>
            </>
              }
            {/* } */}
          </div>
        </div>
        {/* back to list button */}
        <button
          onClick={() => handleNavigate()}
          className=" bg-[#034AFF] py-3 w-1/2 mt-3 mx-auto flex justify-center text-white rounded-xl text-xs md:text-sm lg:text-base"
        >
          Back to list
        </button>
      </div>

      {showPrintOptions ? (
        <Modal
          loadingCallback={loadingCallback}
          navigate={navigate}
          isOpen={showPrintOptions}
          setOpen={setShowPrintOptions}
          title="Print Options"
          formId="choose_print_option"
          type="choosePrintOption"
          //selectType="designation"
          //refetch={()=>setRefetch(val=>!val)}
          //formData={formData}
          //setFormData={setFormData}
          //setWarningMessage={setWarningMessage}
          handlePrint={handlePrint}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default InvoiceDetail;
